import React, { useState } from 'react';
import {MenuProps} from 'antd';
import {Col, Row, Button, Dropdown, Space, message, Tabs, Menu, theme,  Grid} from 'antd';
import { encryption, setCookie, getCookie, clearCookie } from '@/utils'
import { observer } from 'mobx-react-lite'
import './index.scss'
import logoHeader from '@/assets/images/header/logoHeader_b.png'
import logoHeader_ from '@/assets/images/header/logoHeader_b.png'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useStore } from '@/store'
import { DownOutlined, MenuOutlined } from '@ant-design/icons';
import {http} from "@/utils";
import top from "@/assets/images/Entrance/039 Deep Blue(1).png";

const { useToken } = theme;
const { useBreakpoint } = Grid;
function Header() {
    const location = useLocation()
    const pathKeyMap: Record<string, string> = {
        "/Products": "product",
        "/PQ/Trademark": "tmsearch",
        "/PQ/GoodServices": "goods",
        "/PQ/Comparison": "cmpare",
        "/PQ/Monitor": "monitor",
        "/PQ/TrademarkRenewal": "renew",
        "/PQ/ArchiveSearch": "archive",
        "/PQ/BusinessLeads": "bizleads",
        "/RegionalStats": "stats",

        "/DownloadCenter": "resources",
        "/serviceDescription": "services",
        "/PT": "trans",

        "/OrderList": "order",

        "/About": "about",
        "/PrivacyPolicy": "privacy",
        "/ServiceTreaty": "service",
        "/RefundPolicy": "refund",
        "/FAQ": "faq",
    }
    const selectedKey = React.useMemo(() => {
        const pathname = location.pathname
        return pathKeyMap[pathname]
            ? [pathKeyMap[pathname]]
            : []
    }, [location.pathname])

    //获取路由地址
    const { pathname } = useLocation()
    const { token } = useToken();
    const screens = useBreakpoint();
    // 编辑文章 loginStore.loginPopup
    const navigate = useNavigate()
    const { loginStore, userStore } = useStore()
    const signUp = () => {
        loginStore.loginPopup(true)
    }
    const Logout = async () => {
        const authData = await http.delete("/auth/token/logout");
        if (authData.data.code == 0) {
            clearCookie('auth');
            userStore.clearUserInfo()
            navigate('/')
        }
    }
    const items = [
        {label: (<Link to={'/Personal/AccountInformation'}> Personal Center </Link> ), key: '0',},
        {label: (<span onClick={Logout}>Logout</span>),key: '1',}
    ]
    const tabs = [
        {key:"product",label:(<Button type="link" onClick={() => navigate("/Products")}>Products</Button>), children:[
            {key:"tmsearch", label:(<Button type="link" onClick={() => navigate("/PQ/Trademark")}>Trademark Search</Button>)},
            // {key:"imgsearch",label:(<Button type="link" onClick={() => navigate("/PQ/ImageSearch")}>Image Search</Button>)},
            {key:"goods",    label:(<Button type="link" onClick={() => navigate("/PQ/GoodServices")}>Goods and Services</Button>)},
            {key:"cmpare",   label:(<Button type="link" onClick={() => navigate("/PQ/Comparison")}>Trademark Comparison</Button>)},
            {key:"monitor",  label:(<Button type="link" onClick={() => navigate("/PQ/Monitor")}>Trademark Monitoring</Button>)},
            // {key:"renew",    label:(<Button type="link" onClick={() => navigate("/PQ/TrademarkRenewal")}>Trademark Renewal</Button>)},
            {key:"archive",  label:(<Button type="link" onClick={() => navigate("/PQ/ArchiveSearch")}>Trademark Gazette</Button>)},
            // {key:"bizleads",    label:(<Button type="link" onClick={() => navigate("/PQ/BusinessLeads")}>Business Leads</Button>)},
            {key:"stats",label:(<Button type="link" onClick={() => navigate("/RegionalStats")}>Regional Insights</Button>)},
        ]},
        {key:"resources",   label:(<Button type="link" onClick={() => navigate("/DownloadCenter")}>Resources</Button>), children:[
            {key:"services",label:(<Button type="link" onClick={() => navigate("/serviceDescription")}>Services</Button>)},
            {key:"trans",    label:(<Button type="link" onClick={() => navigate("/PT")}>Patent Translation</Button>)},

        ]},
        {key:"order",label:(<Button type="link" onClick={() => navigate("/OrderList")}>Order</Button>)},
        {key:"about",label:(<Button type="link" onClick={() => navigate("/About")}>About Us</Button>), children:[
            {key:"privacy", label:(<Button type="link" onClick={() => navigate("/PrivacyPolicy")}>Privacy Policy</Button>)},
            {key:"service", label:(<Button type="link" onClick={() => navigate("/ServiceTreaty")}>Service Treaty</Button>)},
            {key:"refund",  label:(<Button type="link" onClick={() => navigate("/RefundPolicy")}>Refund Policy</Button>)},
            {key:"faq",     label:(<Button type="link" onClick={() => navigate("/FAQ")}>Frequently Asked Questions</Button>)},

        ]},
    ]
    const [current, setCurrent] = useState("mail");
    const onClick = (e) => {
        console.log("click ", e);
        setCurrent(e.key);
    };
    const styles = {
    container: {
      alignItems: "center",
      display: "flex",
      float:'right',
      position: "relative",
      justifyContent: "space-between",
      //margin: "0 auto",
      padding: screens.md ? `0px ${token.paddingLG}px` : `0px ${token.padding}px`
    },
    header: {
      position: "relative"
    },
    menu: {
      backgroundColor: "transparent",
      borderBottom: "none",
      //width: screens.md ? "inherit" : token.sizeXXL
    },
    menuContainer: {
      //alignItems: "center",
      //margin: " auto 0",
      //position: "relative",
      float:'right',
      display: "flex",
      gap: token.size,
      width: "100%",
      color: "#2B3858"
    },
};
    return(
        <div className={['header', pathname != '/DownloadCenter' && pathname != '/'? 'actives' : ''].join(' ')}>
            <nav style={styles.header}>
            {
                // (!pathname.includes( '/PQ' ) && !pathname.includes( '/Personal' ))
                pathname == '/'|| pathname == 'ProductList' ?
                <img className={'top'} src={top} alt=""/> : null
            }
                <div style={styles.container}>
                    <div style={styles.menuContainer}>
                        <img onClick={() => navigate('/')} className={'logoHeader'} src={logoHeader} alt=""/>
                        <Menu
                            className="headerMenu"
                            mode="horizontal"
                            items={tabs}
                            selectedKeys={screens.md ? selectedKey : []}
                            style={styles.menu}
                            overflowedIndicator={
                                <Button type="link" icon={<MenuOutlined />} />
                            }
                        />

                    </div>
                </div>
            </nav>
            {userStore.userInfo ?
                <div className={'count'}>
                    <Dropdown menu={{ items}}>
                        <a onClick={(e) => e.preventDefault()}>
                            <Space>
                                {
                                    userStore.userInfo.vipType && userStore.userInfo.vipType != 'COMMON' ?
                                    <img style={{marginTop: '3px'}} src={require(`../../assets/images/header/${userStore.userInfo.vipType}.png`)} alt=""/> : null
                                }
                                {userStore.userInfo.email}
                                <DownOutlined />
                            </Space>
                        </a>
                    </Dropdown>
                </div> :
                <Button className={'Sign'} onClick={ signUp } type="primary"> Sign up </Button>
            }
            {/* <Row style={{ width: '100%' }}>
                <Col span={8}>
                    {
                        pathname === '/' ?
                        <img onClick={() => navigate('/')} className={'logoHeader'} src={logoHeader} alt=""/> :
                        <img onClick={() => navigate('/')} className={'logoHeader'} src={logoHeader_} alt=""/>
                    }
                </Col>
                <Col style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end' }} span={16}>
                    <ul>
                        <li className={pathname == '/ProductList' ? 'active' : null} onClick={() => navigate('/ProductList')}>Products</li>
                        <li className={pathname == '/DownloadCenter' ? 'active' : null} onClick={() => navigate('/DownloadCenter')}>Resources</li>
                        <li className={pathname == '/OrderList' ? 'active' : null} onClick={() =>   navigate('/OrderList')}>Order</li>
                        <li class="whitespace-nowrap" className={pathname == '/About' ? 'active' : null} onClick={() => navigate('/About')}>About Us

                        </li>
                    </ul>
                    {userStore.userInfo ?
                        <div className={'count'}>
                            <Dropdown menu={{ items,}}>
                                <a onClick={(e) => e.preventDefault()}>
                                    <Space>
                                        {
                                            userStore.userInfo.vipType && userStore.userInfo.vipType != 'COMMON' ?
                                            <img style={{marginTop: '3px'}} src={require(`../../assets/images/header/${userStore.userInfo.vipType}.png`)} alt=""/> : null
                                        }

                                        {userStore.userInfo.email}
                                        <DownOutlined />
                                    </Space>
                                </a>
                            </Dropdown>
                        </div> :
                        <Button className={'Sign'} onClick={ signUp } type="primary" >
                        Sign up
                        </Button>
                    }
                </Col>
            </Row> */}
        </div>
    )
}

export default observer(Header)
